import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import 'vuetify/src/stylus/app.styl';
import es from 'vuetify/src/locale/es';

// Componentes Vuetify globales (agregar los necesarios) y registrarlos abajo
import { VBtn, VIcon, VFlex, VLayout, VContainer } from 'vuetify/lib';

// Configuracion de Vuetify
Vue.use(Vuetify, {
  components: { VBtn, VIcon, VFlex, VLayout, VContainer },
  options: {
    customProperties: true
  },
  iconfont: 'md',
  lang: {
    locales: { es },
    current: 'es'
  }
});
